"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LockIcon = LockIcon;
var _SvgIcon2 = _interopRequireDefault(require("@mui/material/SvgIcon"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function LockIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon2.default, _extends({
    viewBox: "0 0 12 12"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    clipRule: "evenodd",
    d: "M8.5 4.5V3.5C8.5 2.83696 8.23661 2.20107 7.76777 1.73223C7.29893 1.26339 6.66304 1 6 1C5.33696 1 4.70107 1.26339 4.23223 1.73223C3.76339 2.20107 3.5 2.83696 3.5 3.5V4.5C3.10218 4.5 2.72064 4.65804 2.43934 4.93934C2.15804 5.22064 2 5.60218 2 6V9.5C2 9.89782 2.15804 10.2794 2.43934 10.5607C2.72064 10.842 3.10218 11 3.5 11H8.5C8.89782 11 9.27936 10.842 9.56066 10.5607C9.84196 10.2794 10 9.89782 10 9.5V6C10 5.60218 9.84196 5.22064 9.56066 4.93934C9.27936 4.65804 8.89782 4.5 8.5 4.5ZM4.5 3.64258C4.5 3.24475 4.65804 2.86322 4.93934 2.58192C5.22064 2.30061 5.60218 2.14258 6 2.14258C6.39782 2.14258 6.77936 2.30061 7.06066 2.58192C7.34196 2.86322 7.5 3.24475 7.5 3.64258V4.64258H4.5V3.64258Z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}